import { isFunction } from "../index";
/**
 * The purpose of this class is to do anything that require to do in step by step
 * then when it's finish, it'll call the onFinish method
 * (Work similar to Promise but with the queue control)
 */
class StepCounter{
    queue = [];
    _onFinish = undefined;
    _onError = undefined;
    constructor(onFinish, onError = undefined){
    	this._onFinish = onFinish;
    	this._onError = onError;
    }
    setTarget(targets){
    	this.queue = targets;
    }
    /**
     * Add target to queue
     */
    addTarget(target){
    	this.queue.push(target); 
    }
    onError(error){
    	if(isFunction(this._onError)){
    		this._onError(error);
    	}
    }
    onFinish(){
    	if(isFunction(this._onFinish)){
    		this._onFinish();
    	}
    }
    count(){
    	return this.queue.length;
    }
    /**
     * Start the step.
     * Instantly call onFinish if nothing in queue and callEventNone was true
     * @param {boolean} callEvenNone 
     */
    start(callEvenNone = true){
    	if(this.queue.length === 0){
    		if(callEvenNone){
    			this.onFinish();
    		}
    	}else{
    		this.next();
    	}
    }
    next(){
    	if(this.queue.length > 0){
    		this.queue.shift()(this.next.bind(this));
    	}else{
    		this.onFinish();
    	}
    }
}
export default StepCounter;


// WEBPACK FOOTER //
// ./src/util/helper/StepCounter.js